import { Image } from '../../../components/image';
import { Link } from 'react-router';
import { ReactComponent as ArrowRight } from '../../../icons/svg/arrow/arrow-right.svg';

interface CardSearchCategoryProps {
    category: {
        title: string;
        link: string;
        image: string;
        type: string;
    };
    onClick: () => void;
}

export const CardSearchCategory = ({
    category,
    onClick,
}: CardSearchCategoryProps) => {
    return (
        <Link
            to={category.link}
            onClick={onClick}
            className="relative flex h-28 w-71 cursor-pointer gap-2 rounded-2xl bg-[#f2f2f2] p-[12px] pr-5 hover:bg-brick-800"
        >
            <div className="relative inline-flex h-auto w-1/3 max-w-22 shrink-0 items-center justify-start overflow-hidden rounded-lg bg-white">
                {category.image && (
                    <Image
                        src={category.image}
                        alt={category.title}
                        width={180}
                        height={180}
                        fit="cover"
                    />
                )}
            </div>
            <div className="inline-flex flex-1 flex-col items-start justify-start gap-2 py-[5px]">
                <div className="shrink grow basis-0 self-stretch text-base leading-tight font-medium tracking-tight text-gray-900">
                    <span>{category.title}</span>
                </div>
                <div className="self-stretch text-xs leading-[10px] font-medium tracking-wide text-gray-900 uppercase">
                    {category.type}
                </div>
                <div className="absolute right-[12px] bottom-[12px]">
                    <ArrowRight className="w-[18px]" />
                </div>
            </div>
        </Link>
    );
};
